import { combineReducers } from 'redux';

import profile from 'services/store/profile';

const reducer = combineReducers({
  profile,
});

export default reducer;
